<template>

      <mw-dialog title="选择部门机构" size="mini_mini" :footerButton="btns" ref="zgDeptDialog" :close-on-click-modal="false">
        <mw-tree :url="deptTreeUrl" :multipleLeaf="true" :checkNodes="checkNodes"
                  :async="true" :expandedFirst="true"
                  ref="deptTree" :multiple="true" class="mw-dialog-body" ></mw-tree>
      </mw-dialog>


</template>
<script>
    export default {
        data() {
          return {
            // deptTreeUrl: this.mwUrl('/api/org/listDepartment'),
            checkNodes: [],
            btns: [{
              label: '全选',
              func: this.selectAll
            },{
              label: '不选',
              func: this.resetChecked,
               type: 'default'
            },{
              label: '取消',
              func: this.cancelDept,
              type: 'default'
            },{
              label: '确定',
              func: this.confirmDept
            }]
          }
        },
      computed: {
        deptTreeUrl() {
          // 不是开发账号过滤不显示的部门
          if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
          return this.mwUrl("/api/org/listDepartment")
        }
      },
      methods:{
        selectAll(){
          this.mwRef('deptTree').checkAll();
        },
        resetChecked(){
          this.mwRef('deptTree').unCheckAll();
        },

        confirmDept(){
          this.checkNodes = this.mwRef('deptTree').getSelected();
          this.$emit("confirm",this.checkNodes);
          this.cancelDept();
        },

        cancelDept(){
          this.mwRef('zgDeptDialog').hide();
        },
        getValue(){
          return this.checkNodes;
        },
        show(){
          this.mwRef('zgDeptDialog').show();
        }

      }
    }
</script>




// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/zgDept.vue